import { img, readdy } from '@/utils/images';

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '关于我们', path: '/about' },
  { label: '健康纤体方案', path: '/solutions' },
  { label: '管理团队', path: '/management' },
  { label: '招商加盟', path: '/franchise' },
  { label: '品牌动态', path: '/news' },
  { label: '联系我们', path: '/contact' },
];

export const brandStats = [
  { value: '12+', label: '余年行业积淀' },
  { value: '17+', label: '城市市场覆盖' },
  { value: '200+', label: '品牌合作门店' },
  { value: '38万+', label: '累计服务顾客' },
];

export const solutionFeatures = [
  {
    icon: 'ri-leaf-line',
    title: '中医经络理论融合',
    desc: '以传统中医经络理论为参考，结合现代健康管理理念，为每位顾客提供科学、温和的纤体方案。'
  },
  {
    icon: 'ri-user-heart-line',
    title: '个性化定制方案',
    desc: '根据顾客体质、生活习惯和健康目标，由专业顾问一对一评估，制定专属健康体重管理计划。'
  },
  {
    icon: 'ri-computer-line',
    title: '数字化运营体系',
    desc: '依托数字化管理系统，实现服务流程标准化、数据追踪可视化，确保每家门店服务品质一致。'
  },
];

export const storeManagers = [
  {
    name: '沈晓欢',
    city: '西安',
    experience: '8年',
    philosophy: '用专业和耐心陪伴每一位顾客',
    imagePrompt: 'Professional female slimming consultant in warm beige uniform, smiling warmly in a clean modern wellness store interior with soft natural lighting, professional atmosphere, East Asian appearance, portrait photography style',
    imageUrl: img('readdy/220cd570e742eb76ea077b2dff83c4fa.png'),
  },
  {
    name: '周书兰',
    city: '西安',
    experience: '6年',
    philosophy: '健康纤体是一场温暖的陪伴',
    imagePrompt: 'Confident professional female health consultant with gentle smile, in bright modern wellness center interior, East Asian appearance, soft warm lighting, professional portrait',
    imageUrl: img('readdy/125f6b2b9611adc6affc4b6bf3488675.png'),
  },
  {
    name: '连娟宁',
    city: '西安',
    experience: '10年',
    philosophy: '每一位顾客都值得被用心对待',
    imagePrompt: 'Experienced female wellness store manager in beige professional attire, warm expression, standing in elegant spa-like store environment, East Asian appearance, soft diffused lighting',
    imageUrl: img('readdy/1e1979bf43f8521bf14c76432476b434.png'),
  },
  {
    name: '孙建红',
    city: '西安',
    experience: '5年',
    philosophy: '让健康管理成为一种生活方式',
    imagePrompt: 'Young professional female health store manager smiling naturally, in bright modern wellness store with plants, East Asian appearance, clean natural lighting, lifestyle portrait',
    imageUrl: img('readdy/a12d69f77f6c6b96d4bb103ee540a836.png'),
  },
];

export const experts = [
  {
    name: '刘明远',
    title: '中医顾问',
    specialty: '中医经络调理',
    bio: '从事中医临床与健康管理工作二十余年，专注经络理论与现代体重管理的融合应用。',
    imagePrompt: 'Senior Chinese medicine practitioner in professional attire, warm and wise expression, in a study room with traditional elements, East Asian male, soft warm lighting, professional portrait',
  },
  {
    name: '赵雅琴',
    title: '产品研发顾问',
    specialty: '健康产品研发',
    bio: '十余年健康产品研发经验，致力于天然草本与现代科技相结合的健康管理产品开发。',
    imagePrompt: 'Professional female health product researcher in lab coat, confident and approachable, in modern laboratory setting, East Asian appearance, clean bright lighting',
  },
  {
    name: '孙伟华',
    title: '资深瘦身顾问',
    specialty: '个性化方案设计',
    bio: '八年健康体重管理服务经验，累计为上万名顾客提供个性化纤体方案设计与全程陪伴。',
    imagePrompt: 'Professional male fitness and health consultant in business casual, warm smile, in modern office environment, East Asian appearance, natural lighting',
  },
];

export const franchiseAdvantages = [
  {
    icon: 'ri-store-2-line',
    title: '品牌赋能',
    desc: '十余年品牌积淀，多省市场验证，成熟的门店运营模型可直接复制。'
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '培训体系',
    desc: '总部系统化培训，涵盖产品知识、服务流程、门店管理、顾客维护等全方位内容。'
  },
  {
    icon: 'ri-line-chart-line',
    title: '营销支持',
    desc: '总部统一品牌推广，区域经理协同策划，线上线下结合，持续获取精准客源。'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '售后保障',
    desc: '完善的售后服务体系，区域经理定期巡店，确保门店稳定运营与顾客满意度。'
  },
];

export const newsItems = [
  {
    id: 1,
    title: '颜轻至2026夏季新品发布会圆满落幕',
    date: '2026-05-20',
    category: '品牌新闻',
    summary: '5月18日，颜轻至在西安举办夏季新品发布会，推出全新草本护理系列产品。',
    image: img('readdy/0d1b5a9353617e3faa6de65143901729.png'),
    imagePrompt: 'Elegant product launch event scene with warm beige and cream color scheme, stage with brand logo, professional atmosphere, soft lighting, event photography style',
  },
  {
    id: 2,
    title: '第三期店长训练营在郑州圆满结营',
    date: '2026-05-12',
    category: '培训赋能',
    summary: '为期一周的店长训练营顺利结业，来自全国各地的30余位店长完成系统化培训。',
    image: img('readdy/d68b73045aa18e4768514feac9cf8887.png'),
    imagePrompt: 'Group training session in bright modern classroom, professional wellness consultants learning together, warm atmosphere, East Asian people, educational setting',
  },
  {
    id: 3,
    title: '颜轻至江西南昌旗舰店盛大开业',
    date: '2026-05-05',
    category: '门店动态',
    summary: '南昌首家旗舰店正式开业，为当地顾客带来专业、个性化的健康纤体服务体验。',
    image: img('readdy/85e56cf1c84578c9f64423a1affe9331.png'),
    imagePrompt: 'Grand opening of modern elegant wellness store with warm lighting, welcoming entrance with plants and beige decor, upscale retail atmosphere, architectural photography',
  },
];

// 以下数据沿用，母公司从"麦杰健康"更新为"麦杰集团"
export const footerLinks = {
  brand: [
    { label: '关于我们', path: '/about' },
    { label: '品牌动态', path: '/news' },
  ],
  solutions: [
    { label: '健康纤体方案', path: '/solutions' },
    { label: '管理团队', path: '/management' },
    { label: '联系我们', path: '/contact' },
  ],
  franchise: [
    { label: '招商加盟', path: '/franchise' },
    { label: '加盟优势', path: '/franchise' },
    { label: '申请加盟', path: '/franchise' },
  ],
};